<template>
	<v-container fluid>
		<div v-if="!loading">
			<!--table-->
			<!--table head-->
			<v-row class="total mt-8" no-gutters>
				<v-col class="tabCell text-left">Product</v-col>
				<v-col v-for="item in headers"
					class="tabCell"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<!--table content-->
			<v-expansion-panels multiple v-model="panel">
				<v-expansion-panel
					v-for="brand in products"
					:key="brand.id"
				>
					<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
						{{ brand.trademark }}
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row v-for="model in sortedModels(brand.models)" :key="model.id" no-gutters>
							<v-col class="tabCell text-left">{{ name(model.model) }}</v-col>
							<v-col class="tabCell">{{ status(model.availablefrom, model.availabletill)}}</v-col>
							<v-col class="tabCell">{{ model.designType}}</v-col>
							<v-col class="tabCell">{{ model.designLevel}}</v-col>
							<v-col class="tabCell">{{ model.material }}</v-col>
							<v-col class="tabCell">{{ model.manufacturing }}</v-col>
							<v-col class="tabCell">{{ model.variations }}</v-col>
							<v-col class="tabCell">{{ model.advancedFeature }}</v-col>
							<v-col class="tabCell">{{ model.unitCost }}</v-col>
							<v-col class="tabCell accentColor">{{ format(model.salesPlan) }}</v-col>
							<v-col class="tabCell accentColor">{{ format(model.productionPlan) }}</v-col>
							<v-col class="tabCell accentColor">{{ format(model.retailPrice) }}</v-col>	
							<v-col class="tabCell accentColor">{{ format(model.price) }}</v-col>
							<v-col class="tabCell">{{ format(model.inventories) }}</v-col>
							<v-col class="tabCell">
								<upgrade-sales 
									:brand="brand" 
									:model="model"
									:gameId="gameId"
									:round="round">
								</upgrade-sales>
							</v-col>
						</v-row>
						<v-row class="total mt-4" no-gutters>
							<v-col cols="3" class="total text-left">Total sales (units):</v-col>
							<v-col cols="2" class="total text-left">{{ format(totalSales(brand)) }}</v-col>
						</v-row>
						<v-row class="total" no-gutters>
							<v-col cols="3" class="total text-left">Sales value (estimated):</v-col>
							<v-col cols="2" class="total text-left">{{ salesValue(brand) }}</v-col>
						</v-row>
						<v-row class="total" no-gutters>
							<v-col cols="3" class="total text-left">Gross marging (estimated):</v-col>
							<v-col cols="2" class="total text-left">{{ grossMargin(brand) }}</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div>
	</v-container>
</template>
<script>
	import upgradeSales from '../products/upgradeSales.vue'
	import Loader from '../../layouts/Loader.vue'
	import numeral from 'numeral'

	export default {
		props: ['company', 'gameId', 'round'],
		data (){
			return {
				icon: 'arrow_right',
				headers: ['Available', 'Design type', 'Design level', 'Material', 'Manufacturing', 'Variations','Advanced feature', 'Unit cost', 'Sales plan', 'Production plan', 'Price in retail', 'Price ex-works', 'Inventories', 'Action'],
				panel: [0],
				monthsName: ['Jun', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			products () {
				return this.$store.getters.products
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')
			},
			name (model) {
				return model.split(' - ')[1] //trademark cutted name
			},
			status (from, till) {
				if (till < 12) return `till ${(this.monthsName[till-1])}`
				else if (from > 1) return `from ${this.monthsName[from-1]}`
				else  return 'available'
			},
			totalSales (brand) {
				const res = brand.models.reduce((summ, model) => {
					return summ + parseInt(model.salesPlan)
				}, 0)
				return res
			},
			salesValue (brand) {
				const res = brand.models.reduce((summ, model) => {
					return summ + (parseInt(model.salesPlan) * parseFloat(model.price))
				}, 0)
				return numeral(res).format('0,0[.]0')
			},
			grossMargin (brand) {
				const res = brand.models.reduce((summ, model) => {
					return summ + parseInt(model.salesPlan) * (parseFloat(model.price) - parseFloat(model.unitCost))
				}, 0)

				return numeral(res).format('0,0[.]0')
			},
			sortArrObjs (arr) {
				//sort models
				arr.sort((prev, next) => {
					let p = prev.model.toLowerCase()
					let n = next.model.toLowerCase()
					if (p < n) return -1;
					if (p > n) return 1;
					return 0;
				})
				return arr
			},
			sortedModels(models) {
				//first available
				let availableArr = []
				let inProgressArr = []
				models.forEach(model => {
					if (model.availablefrom  !== 1) {
						inProgressArr.push(model)
					}
					else {
						availableArr.push(model)
					}
				} )
				
				availableArr = this.sortArrObjs(availableArr)
				inProgressArr = this.sortArrObjs(inProgressArr)

				return availableArr.concat(inProgressArr)
			}
		},
		components: {
			upgradeSales,
			Loader
		}
	}
</script>
